/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import MainHeader from '../header';
import MealtristHeader from '../Core/mealtristHeader';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';
import '../../App.css';
import 'font-awesome/css/font-awesome.css';
import swal from 'sweetalert';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // ES6
import MealtristFooter from "../Core/mealtrist-footer";

class ShowMeal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isAuthor: false, uploadUrl: "", user: "", meal: "", ingredients: "", imgFile: "", loggedIn: false, messageStatus: ""};
        this.createMarkup = this.createMarkup.bind(this);
        this.capitalizeWords = this.capitalizeWords.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.onSelectImage = this.onSelectImage.bind(this);
        this.deleteMealSwal = this.deleteMealSwal.bind(this);
        this.deleteMeal = this.deleteMeal.bind(this);
        this.emptyCheck = this.emptyCheck.bind(this);
    }

    componentWillMount() {
    }

    capitalizeWords(str)
    {
        if(typeof(str) !== "undefined") {
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }
    }

    createMarkup(text) {
        return {__html: text};
    }

    deleteMealSwal(mealId) {
        swal({
            title: "Are you sure?",
            text: "Deleting the meal here will remove it permanently.",
            buttons: {
                cancel: "Cancel",
                category: {
                    text: "Delete Meal",
                    value: "meal",
                }
            },
            dangerMode: true,
            icon: "warning",
        })
            .then((value) => {
                switch (value) {
                    case "meal":
                        this.setState(prevState => ({
                            messageStatus: "loading"
                        }));
                        this.deleteMeal(mealId);
                        break;

                    default: break;
                }
            });
    }

    deleteMeal( mealId = 0)
    {
        if(mealId > 0) {
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/meal/delete/' + mealId,
                                        type: 'post',
                                        async: false,
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    messageStatus: "success"
                                                }));

                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    onSelectImage(event) {
        event.preventDefault();
        let reader = new FileReader();
        let file = event.target.files[0];
        let imgUrl = window.URL.createObjectURL(file);
        console.log(file);
        this.setState({imgFile: event.target.id});
        this.setState({uploadUrl: imgUrl});
        console.log(this.state.imgFile);
    }

    submitMeal() {
        console.log("printing file");
        console.log(this.state.imgFile);
        let currentImg = null;
        currentImg = document.getElementById(this.state.imgFile);
        let reader = new FileReader();
        let file = currentImg.files[0];
        console.log(file);
        let name = this.state.name;

        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };
        if (!!file.type.match(/image.*/)) {
            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    if (typeof(response.data.id) !== 'undefined') {
                                        let myFormData = new FormData();
                                        myFormData.append('image[]', file);
                                        myFormData.append('name', name);
                                        myFormData.append('privacy', globalThis.state.privacy);
                                        myFormData.append('calories', globalThis.state.calories);
                                        myFormData.append('carbohydrates', globalThis.state.carbohydrates);
                                        myFormData.append('cholesterol', globalThis.state.cholesterol);
                                        myFormData.append('fat', globalThis.state.fat);
                                        myFormData.append('fiber', globalThis.state.fiber);
                                        myFormData.append('protein', globalThis.state.protein);
                                        myFormData.append('saturatedFat', globalThis.state.saturatedFat);
                                        myFormData.append('servingSize', globalThis.state.servingSize);
                                        myFormData.append('sodium', globalThis.state.sodium);
                                        myFormData.append('sugar', globalThis.state.sugar);
                                        myFormData.append('transFat', globalThis.state.transFat);
                                        myFormData.append('unsaturatedFat', globalThis.state.unsaturatedFat);
                                        myFormData.append('cookingTime', globalThis.state.cookingTime);
                                        myFormData.append('prepTime', globalThis.state.prepTime);
                                        myFormData.append('totalCookTime', globalThis.state.totalCookTime);
                                        myFormData.append('cookingMethod', globalThis.state.cookingMethod);
                                        myFormData.append('cuisine', globalThis.state.cuisine);
                                        myFormData.append('diet', globalThis.state.diet);
                                        myFormData.append('descriptions', globalThis.state.descriptions);
                                        myFormData.append('instructions', globalThis.state.instructions);
                                        myFormData.append('mealRating', globalThis.state.mealRating);
                                        myFormData.append('mealCategory', globalThis.state.mealCategory);
                                        myFormData.append('ingredientCount', JSON.stringify(globalThis.state.ingredientCount));


                                        //TESTING COMPLETE ORDERS
                                        $.ajax({
                                            url: process.env.REACT_APP_API_HOST + '/' + 'api/mealpic/upload',
                                            type: "POST",
                                            data: myFormData,
                                            processData: false,
                                            contentType: false,
                                            'headers': {
                                                // Use access_token previously retrieved from inContact token
                                                // service.
                                                'Authorization': 'Bearer ' + user.token,
                                            },
                                            error: function (response) {
                                                //Failed response
                                                // logOrderError(visitID, 'otsError', completeOrderData, response);
                                            },
                                            success: function (response) {
                                                console.log('image response');
                                                console.log(response);
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    componentWillMount() {
        let mealId = Number(this.props.match.params.id);
        if(mealId && mealId !== '' && mealId === parseInt(mealId, 10)) {
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (authResponse) {
                        if (typeof(authResponse.message) !== 'undefined') {
                            if (authResponse.message.indexOf('authenticated_user') > -1) {
                                if (typeof(authResponse.data) !== 'undefined') {
                                    if (typeof(authResponse.data.id) !== 'undefined') {
                                        globalThis.setState(prevState => ({
                                            loggedIn: true
                                        }));
                                        globalThis.setState(prevState => ({
                                            user: authResponse.data
                                        }));
                                        $.ajax({
                                            url: process.env.REACT_APP_API_HOST + '/' + 'api/meal/show/' + mealId,
                                            type: 'post',
                                            async: false,
                                            'headers': {
                                                // Use access_token previously retrieved from inContact token
                                                // service.
                                                'Authorization': 'Bearer ' + user.token,
                                            },
                                            error: function (response) {
                                                //Failed response
                                                // logOrderError(visitID, 'otsError', completeOrderData, response);
                                            },
                                            success: function (response) {
                                                if(typeof (response) !== 'undefined') {
                                                    globalThis.setState(prevState => ({
                                                        meal: response.meal
                                                    }));
                                                    globalThis.setState(prevState => ({
                                                        ingredients: response.ingredients
                                                    }));
                                                    if(response.meal && authResponse.data.id === response.meal.user_id) {
                                                        globalThis.setState(prevState => ({
                                                            isAuthor: true
                                                        }));
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    }



    handleKeyUp(e) {
        var globalThis = this;
        if (e.keyCode === 13) {
            globalThis.triggerChange();
        }
    }

    emptyCheck(value) {
        if (value && value === null || value === "null" || !value || value === 'undefined') {
            return ""
        }
        return value;
    }

    //TODO set referrer url link in containers first child link
    render() {

        const header = {
            use: ""
        }
        let output = "";
        let mealHtml = "";
        let meal = "";
        let ingredientList = "";
        if(this.state.meal !== "") {
            console.log("printing meal");
            console.log(this.state.meal);
            meal = this.state.meal;
            if (this.state.ingredients !== "") {
                ingredientList = this.state.ingredients.map((ing, ingIndex) => {
                    return <ReactBootstrap.ListGroupItem key={"ingredient" + ''+ingIndex} className="text-center" >{ing.amount + " " + ing.measurement + " of " +ing.item}</ReactBootstrap.ListGroupItem>
                });
            }
            mealHtml = <div>
                <h2 className="text-center">{this.emptyCheck(meal.name)}</h2>
                <h3 className="text-center">{'By ' + meal.author}</h3>
                <h3 className="text-center">{'Course: ' + meal.course}</h3>
                <h3 className="text-center">{'Privacy: ' + meal.privacy + ' - Meal Rating: ' + meal.rating}</h3>
                <br></br>
                <img className="center-block img-responsive" src={ this.emptyCheck(meal.picture)} />
                <br></br>
                <ReactBootstrap.Table responsive>
                    <tbody>
                    <tr>
                        <td><b>{'Carbs: ' + this.emptyCheck(meal.carbs)}</b></td>
                        <td><b>{'Fat: ' + this.emptyCheck(meal.fat)}</b></td>
                        <td><b>{'Fiber: ' + this.emptyCheck(meal.fiber)}</b></td>
                        <td><b>{'Sodium: ' + this.emptyCheck(meal.sodium)}</b></td>
                    </tr>
                    <tr>
                        <td><b>{'Calories: ' + this.emptyCheck(meal.calories)}</b></td>
                        <td><b>{'SaturatedFat: ' + this.emptyCheck(meal.saturatedFat)}</b></td>
                        <td><b>{'Protein: ' + this.emptyCheck(meal.protein)}</b></td>
                        <td><b>{'Carbs: ' + this.emptyCheck(meal.carbs)}</b></td>
                    </tr>
                    <tr>
                        <td><b>{'Cholesterol: ' + this.emptyCheck(meal.cholesterol)}</b></td>
                        <td><b>{'SaturatedFat: ' + this.emptyCheck(meal.unsaturatedFat)}</b></td>
                        <td><b>{'Sugar: ' + this.emptyCheck(meal.sugar)}</b></td>
                        <td><b>{'TransFat: ' + this.emptyCheck(meal.transFat)}</b></td>
                    </tr>
                    </tbody>
                </ReactBootstrap.Table>
                <br></br>
                <ReactBootstrap.Table striped bordered condensed hover>
                    <tbody>
                    <tr>
                        <td className="text-center"><b>{'Prep Time: ' + this.emptyCheck(meal.prepTime)}</b></td>
                        <td className="text-center"><b>{'Cooking Time: ' + this.emptyCheck(meal.cookTime)}</b></td>
                        <td className="text-center"><b>{'Total Cook Time: ' + this.emptyCheck(meal.totalTime)}</b></td>
                    </tr>
                    </tbody>
                </ReactBootstrap.Table>
                {(meal.cookingMethod !== "" && meal.cookingMethod !== null && meal.cookingMethod !== 'null') &&
                <div><br></br><h3>Cooking Method: {meal.cookingMethod}</h3></div>
                }
                {(meal.cuisine !== "" && meal.cuisine !== null) &&
                <div><br></br><h3>Cuisine: {this.emptyCheck(meal.cuisine)}</h3></div>
                }
                <br></br>
                {ingredientList !== "" &&
                <div>
                    <h3 className="text-center">Ingredients</h3><br></br>
                    <ReactBootstrap.ListGroup>
                    {ingredientList}
                    </ReactBootstrap.ListGroup>
                    <br></br>
                </div>
                }
                <h2 className="text-center">Description</h2>
                <p dangerouslySetInnerHTML={this.createMarkup(meal.description)}></p>
                <br></br>
                <h2 className="text-center">Instructions</h2>
                <p dangerouslySetInnerHTML={this.createMarkup(meal.instructions)}></p>
            </div>
        }
        console.log("printing id");
        if(this.state.meal !== "") {
            console.log(this.state.meal.user_id);
            console.log(this.state.user.id);
        }
        let form = "";
        form = mealHtml;
        if(this.state.loggedIn === true) {
            header.use = <MealtristHeader/>;
            output = <div>
                <div className="container main-body-content">
                {header.use}
                    {this.state.messageStatus === "loading" &&
                    <div>
                        <div className="row">
                            <br></br>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                                <i className="text-center fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.messageStatus === "success" &&
                    <div>
                        <div className="row">
                            <br></br>
                            <div className="text-center">
                                <h2 className="text-danger">Your meal has been successfully deleted.</h2>
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.messageStatus === "" &&
                        <div>
                    {this.state.meal !== "" && (this.state.meal.user_id == this.state.user.id) &&
                    <div className="row">
                        <div className="col-sm-9">
                        </div>
                        <div className="col-sm-3">
                            <div className="col-sm-12">
                                <div className="col-sm-6">
                                    <Link to={'/meal-edit/' + this.state.meal.id}>
                                        <ReactBootstrap.ButtonToolbar>
                                            <ReactBootstrap.Button bsSize="small">Edit
                                                Meal</ReactBootstrap.Button>
                                        </ReactBootstrap.ButtonToolbar>
                                    </Link>
                                </div>
                                <div className="col-sm-6">
                                    <ReactBootstrap.ButtonToolbar>
                                        <ReactBootstrap.Button bsSize="small"
                                                               onClick={this.deleteMealSwal.bind(this, this.state.meal.id)}>Delete
                                            Meal</ReactBootstrap.Button>
                                    </ReactBootstrap.ButtonToolbar>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    {form}
                        </div>
                    }
                </div>
                <MealtristFooter/>
            </div>
        } else {
            header.use = <MainHeader/>;
            output =
                <div>
                    {header.use}
                    <div className="text-center main-body-content">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                    </div>
                    <MealtristFooter/>
                </div>
        }
        return (
                output
        );
    }
}

export default ShowMeal;


// WEBPACK FOOTER //
// ./src/components/Mealtrist/showMeal.js